export default __webpack_public_path__ + "static/media/Screenshot (1076).c72a599c.png";